import React, {useCallback, useRef} from "react";
import { useSearchParams } from "react-router-dom";
import { ProjectFormNavigationContext, ProjectFormNavigationContextProps, ProjectFormPageKey } from "./project-form-navigation-context-props.ts";

const ProjectFormNavigationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const getParam = useCallback(<T extends string = string>(paramName: string): T | undefined => 
        (searchParams.get(paramName) as T | null) ?? undefined, [searchParams]);

    const hasParam = useCallback((paramName: string): boolean => 
        searchParams.has(paramName), [searchParams]);
    
    const route = getParam<ProjectFormPageKey>('tab') || 'organisation';
    
    const fromRef = useRef<ProjectFormPageKey | undefined>(undefined);

    const setRoute = useCallback((newStep: ProjectFormPageKey, queryParams?: URLSearchParams, from?: ProjectFormPageKey) => {
        const next = new URLSearchParams();
        next.set("tab", newStep);
        queryParams?.forEach((value, key) => {
            if (key !== "tab") {
                next.append(key, value);
            }
        });
        
        setSearchParams(next);
        fromRef.current = from;
    }, [setSearchParams]);
    
    const getFrom = useCallback(() => {
        const from = fromRef.current;
        fromRef.current = undefined;
        return from;
    }, []);

    const contextProps: ProjectFormNavigationContextProps = {
        route,
        setRoute,

        hasParam,
        getParam,
        getFrom,
    };

    return (
        <ProjectFormNavigationContext.Provider value={contextProps}>
            {children}
        </ProjectFormNavigationContext.Provider>
    )
};

export default ProjectFormNavigationProvider;